import { lazy } from "react";

const TAModule = lazy(() => import("../../../../Pages/TADAWorking/TAModule"));
const ShowTA_DAData = lazy(() => import("../../../../Pages/TADAWorking/showTA_DAData"));
const ShowData = lazy(() => import("../../../../Pages/TAData/ShowData"));
const GroupTravel = lazy(() => import("../../../Common/Travel/createGroupTravel"));
const CityManager = lazy(() => import("../../../../Pages/TAData/TaDaCity/AddCityManager"));

export const TADARoute= [
  { path: "expenseEase", element: <TAModule /> },
  { path: "showTA_DAData", element: <ShowTA_DAData /> },
  { path: "showFullData", element: <ShowData /> },
  { path: "groupTravel", element: <GroupTravel /> },
  { path: "cityManager", element: <CityManager /> }
];
